<div class="main-content flex">
  <div class="border-right">
    <app-graph-form componentContext="dataset-page" [collection]="collection" [datasetPageVariablesList]="variableKeys"></app-graph-form>
  </div>
  <div class="col-8 p-5 graph-column">
    <app-graph-type componentContext="dataset-page"></app-graph-type>
    <!--
      #29 — the chart-enabled keys are the eligibility half of the request-validity gate,
      so restored state cannot replay a variable that #24 has disabled for this dataset.
    -->
    <app-graph componentContext="dataset-page" [collection]="collection" [chartEnabledKeys]="variableKeys"></app-graph>
    <div class="mt-5">
      <app-graph-data-transformers componentContext="dataset-page"></app-graph-data-transformers>
    </div>
  </div>
</div>

<app-graph-selected-variables-list componentContext="dataset-page" [collection]="collection" [chartEnabledKeys]="variableKeys"></app-graph-selected-variables-list>
